import { ModuleNode } from '../types';

export const finopsExecutiveModule: ModuleNode = {
	key: 'finopsExecutive',
	title: 'FinOps Executive',
	route: '/finops/executive',
	pages: [
		{
			key: 'cost-summary',
			title: 'FinOps Executive Dashboard',
			route: '/finops/executive?tab=3',
			items: [
				{
					key: 'azure-cloud-cost',
					label: 'Azure Cloud Cost by Programs',
					tags: ['Azure Cloud Cost', 'cloud', 'cost', 'azure', 'executive', 'sector', 'programs', 'projects']
				},
				{
					key: 'cost-trend',
					label: 'Cost Trend by Programs',
					tags: ['Cost Trend', 'trend', 'cost', 'executive', 'sector', 'programs', 'projects']
				},
				{
					key: 'cost-distribution',
					label: 'Cost Distribution by Sectors',
					tags: ['Cost Distribution', 'distribution', 'cost', 'sectors', 'executive', 'programs', 'projects']
				},
				{
					key: 'top-programs-cost',
					label: 'Top Programs By Cost',
					tags: ['Top Programs', 'cost', 'sector', 'executive', 'programs', 'projects']
				},
				{
					key: 'azure-cloud-cost-by-technology',
					label: 'Azure Cloud Cost by Technology',
					tags: ['Azure Cloud Cost', 'cloud', 'cost', 'azure', 'technology']
				},
				{
					key: 'cost-trend-by-technology',
					label: 'Cost Trend by Technology',
					tags: ['Cost Trend', 'trend', 'cost', 'technology']
				}
			]
		},
		{
			key: 'executive-dashboard',
			title: 'FinOps Executive Dashboard',
			route: '/finops/executive',
			items: [
				{
					key: 'total-spent-ytd',
					label: 'Total Spend (YTD)',
					tags: ['spent', 'spend', 'actual', 'cost', 'ytd', 'total', 'year to date']
				},
				{
					key: 'aop',
					label: 'AOP 2026',
					tags: ['aop', 'budget', 'plan', 'annual', 'operating', '2026']
				},
				{
					key: 'variance',
					label: 'Trend Line Increment 2026',
					tags: ['variance', 'trend', 'increment', 'difference', 'forecast', '2026']
				},
				{
					key: 'forecast',
					label: 'Final Forecast 2025',
					tags: ['forecast', 'predicted', 'projection', 'final', '2025']
				},
				{
					key: 'monthly-trend',
					label: 'Spend vs Forecast & AOP Target (Monthly)',
					tags: ['trend', 'chart', 'monthly', 'graph', 'spend', 'forecast', 'aop', 'target']
				},
				{
					key: 'spend-program',
					label: 'Spend By Program (Top 5)',
					tags: ['program', 'spend', 'table', 'top 5', 'top five']
				},
				{
					key: 'spend-sector',
					label: 'Spend By Sector (Top 5)',
					tags: ['sector', 'spend', 'table', 'top 5', 'top five']
				},
				{
					key: 'spend-platform',
					label: 'Spend By Platform (Top 5)',
					tags: ['platform', 'spend', 'table', 'top 5', 'top five']
				}
			]
		}
	]
};
